module.exports = __webpack_public_path__ + "img/workplace.b3c4218b.svg";